import { ResponseData } from "./authService";
import { BaseService } from "./baseService";

class ProvidersService extends BaseService<any> {
  controllerName = "providers";

  async getProviders(): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.get<ResponseData<any>>(
      `/${this.controllerName}`
    );
    return data;
  }

  async getProvidersTypesCards(id: string): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.get<ResponseData<any>>(
      `/${this.controllerName}/cards/${id}`
    );
    return data;
  }

  async getProvidersTypesCollection(
    id: string,
    params?: { queryName: string; limit?: number }
  ): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.get<ResponseData<any>>(
      `/${this.controllerName}/collection/${id}`,
      { params }
    );
    return data;
  }
}

export const providerService = new ProvidersService();
